var map = {
	"./EVO.png": 1676,
	"./Path 20295.png": 1677,
	"./ab-img.webp": 1678,
	"./ab-title-cn.webp": 1679,
	"./ab-title-en.webp": 1680,
	"./ag-img.png": 1681,
	"./ag-img.webp": 1682,
	"./ag-title-cn.webp": 1683,
	"./ag-title-en.webp": 1684,
	"./chess-img.webp": 1685,
	"./coin-img.webp": 1686,
	"./content-img.webp": 1687,
	"./dg-img.webp": 1688,
	"./dg-title-cn.webp": 1689,
	"./dg-title-en.webp": 1690,
	"./diamond-img.webp": 1691,
	"./dice-coin.webp": 1692,
	"./ea-img.webp": 1693,
	"./ea-title-cn.webp": 1694,
	"./ea-title-en.webp": 1695,
	"./evo-img.webp": 1696,
	"./evo-title-cn.webp": 1697,
	"./evo-title-en.webp": 1698,
	"./golddice-img.webp": 1699,
	"./gp-img.webp": 1700,
	"./gp-title-cn.webp": 1701,
	"./gp-title-en.webp": 1702,
	"./heart-coin-img.webp": 1703,
	"./lc-bg.webp": 1704,
	"./mg-img.webp": 1705,
	"./mg-title-cn.webp": 1706,
	"./mg-title-en.webp": 1707,
	"./pp-img.webp": 1708,
	"./pp-title-cn.webp": 1709,
	"./pp-title-en.webp": 1710,
	"./pt-img.webp": 1711,
	"./pt-title-cn.webp": 1712,
	"./pt-title-en.webp": 1713,
	"./sa-img.webp": 1714,
	"./sa-title-cn.webp": 1715,
	"./sa-title-en.webp": 1716,
	"./sbo-img.webp": 1717,
	"./sbo-title-cn.webp": 1718,
	"./sbo-title-en.webp": 1719,
	"./spade-img.webp": 1720,
	"./title-cn.webp": 1721,
	"./title-en.webp": 1722,
	"./white-spade-img.webp": 1723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1675;